import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LeftPanelContainer } from './LeftPanelContainer';
import { RightPanelContainer } from './RightPanelContainer';
import TemplateSelector from '../TemplateSelector';
import { ResizablePanels } from '../../../../core-components/theme/components/ResizablePanels';
import SpriteIcon from '../../../../core-components/assets/Icon';
import { useOCRStore } from '../../store/ocrStore';

interface OCRMainContainerProps {
  isEditMode?: boolean;
}

export const OCRMainContainer: React.FC<OCRMainContainerProps> = ({ isEditMode }) => {
  const { t } = useTranslation();
  const selectedTemplate = useOCRStore(state => state.selectedTemplate);

  return (
    <Box sx={{ height: 'calc(100% - 1.5rem)' }}>
      {!isEditMode && <TemplateSelector />}

      {isEditMode && selectedTemplate && (
        <Box sx={{ py: 2 }}>
          <Typography variant="h6">
            {t('logbookConfig.editing', 'Editing')}:{' '}
            <Typography component="span" color="primary.main" fontWeight={600}>
              {selectedTemplate.name}
            </Typography>
          </Typography>
        </Box>
      )}

      {selectedTemplate ? (
        <Box sx={{ height: '90%', mt: isEditMode ? 0 : 2 }}>
          <ResizablePanels
            primary={<LeftPanelContainer />}
            secondary={<RightPanelContainer />}
            direction="horizontal"
            layoutKey="ocrLogbookSplit"
          />
        </Box>
      ) : (
        !isEditMode && (
          <Box
            sx={{
              mt: 4,
              minHeight: 300,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <SpriteIcon id="logbook" width="400" height="400" />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {t('logbookConfig.chooseLogbookTemplateToConfigure', 'Choose logbook template to configure')}
            </Typography>
          </Box>
        )
      )}
    </Box>
  );
};
